import { DataGridPro, gridClasses, useGridApiRef } from '@mui/x-data-grid-pro';

import { SvbrgCatalogueItem } from '@/generated/gql/graphql';
import { useCatalogueSearchResultDataGrid } from '~/routes/IntakeChat/components/CatalogSearchResult/CatalogSearchResult.dataGrid';

interface CatalogueDataGridProps {
  // Optional check ID for selection functionality
  checkId?: string;
  rows: SvbrgCatalogueItem[];
}

export const CatalogueDataGrid = ({ checkId, rows }: CatalogueDataGridProps) => {
  const config = useCatalogueSearchResultDataGrid({ checkId });
  const apiRef = useGridApiRef();

  return (
    <DataGridPro
      {...config}
      sx={{
        [`&.${gridClasses.root}`]: {
          '--DataGrid-containerBackground': 'transparent',
        },
      }}
      apiRef={apiRef}
      hideFooter
      disableColumnMenu
      rows={rows}
      pinnedColumns={{
        right: ['select'],
      }}
    />
  );
};
